module.exports = __webpack_public_path__ + "static/img/logo3-sfr.3595c2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo3-sfr.png
// module id = d18Q
// module chunks = 1